export const muiDataTables = {
   ES: {
      body: {
         noMatch: 'Lo siento, no se encontraron coincidencias',
         toolTip: 'Ordenar',
         columnHeaderTooltip: (column) => `Ordenar por ${column.label}`
      },
      pagination: {
         next: 'Siguiente Página',
         previous: 'Anterior Página',
         rowsPerPage: 'Filas por página:',
         displayRows: 'de'
      },
      toolbar: {
         search: 'Buscar',
         downloadCsv: 'Descargar CSV',
         print: 'Imprimir',
         viewColumns: 'Ver Columnas',
         filterTable: 'Filtrar Tabla'
      },
      filter: {
         all: 'Todos',
         title: 'FILTROS',
         reset: 'REINICIAR'
      },
      viewColumns: {
         title: 'Mostrar Columnas',
         titleAria: 'Mostrar/Ocultar Columnas'
      },
      selectedRows: {
         text: 'fila(s) elegidas',
         delete: 'Eliminar',
         deleteAria: 'Eliminar Filas Elegidas'
      }
   }
};
